var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionInfo01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 9,
    fill: "#F5F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 32H15C13.3432 32 12 30.6569 12 29V13C12 12.4477 12.4477 12 13 12H27C27.5523 12 28 12.4477 28 13V20H32V29C32 30.6569 30.6569 32 29 32ZM28 22V29C28 29.5523 28.4477 30 29 30C29.5523 30 30 29.5523 30 29V22H28ZM15 16V22H21V16H15ZM15 23V25H25V23H15ZM15 26V28H25V26H15ZM17 18H19V20H17V18Z",
    fill: "url(#paint0_linear_1788_10330)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1788_10330",
    x1: 10.4431,
    y1: 4.15686,
    x2: 55.8986,
    y2: 9.04737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A8EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F3AFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionInfo01);
export default __webpack_public_path__ + "static/media/subscription_info01.ca362b9894f1cabafa74bce7f05e31f3.svg";
export { ForwardRef as ReactComponent };